import { useState, useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Navbar from "../components/Navbar/Navbar";
import VortexUserProfile from "./VortexUser/UserProfile";
import Sidebar from "../components/Sidebar/Sidebar";
import User from "./User/User";
import Content from "./Content/Content";
import Notifications from "./Notifications/Notifications";
import VortexNotification from "./VortexNotifications/Notifications";
import VortexAppManager from "./VotexAppManager/AppManager";
import UserProfile from "./User/UserProfile";
import Login from "./Login/Login";
import DataAnalysis from "./DataAnalysis/DataAnalysis";
import Settings from "./Settings/Settings";
import Security from "./Security/Security";
import Reporting from "./Reporting/Reporting";
import AppManager from "./AppManager/AppManager";
import Email from "./Email/Email";
import VortexEmail from "./VortexEmail/Email";
import VortexDataAnalysis from "./VortexDataAnalysis/DataAnalysis";
import VortexUser from "./VortexUser/User";

const AuthorizedCom = () => {
  const [token, setToken] = useState("");
  const navigate = useNavigate(); // Hook for navigation
  const location = useLocation(); // Hook to get current location
  const [activeTab, setActiveTab] = useState("legacy");

  const handleTabChange = (tab) => {
    if (tab === "legacy") {
      navigate("/");
    } else if (tab === "vortex") {
      navigate("/vortexData");
    }
    setActiveTab(tab);
  };
  // Retrieve token from localStorage on component mount
  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      setToken(accessToken);
    } else {
      // If token is not present, navigate to login
      navigate("/login");
    }
  }, [navigate]);

  // Check if current location is login page
  const isLoginPage = location.pathname === "/login";

  return (
    <div>
      {/* Conditionally render Sidebar and Navbar */}

      <div className="w-full relative bg-gray-400 overflow-hidden flex flex-col items-center justify-start  pb-[2.125rem] pr-[1.5rem] pl-[2.188rem] box-border gap-[0.875rem_0rem] tracking-[normal]">
        {!isLoginPage && <Navbar tab={activeTab} changeTab={handleTabChange} />}

        <main className="self-stretch flex flex-row bg-black items-start justify-start gap-[0rem_0.875rem] max-w-full shrink-0 text-left text-[1.125rem] text-gray-200 font-gilroy">
          {!isLoginPage && activeTab === "legacy" && <Sidebar />}
          <Routes>
            {/* Render DataAnalysis if token exists */}
            {token ? (
              <Route path="/" element={<DataAnalysis />} />
            ) : (
              // Otherwise, redirect to login
              <Route path="/" element={<Navigate to="/login" />} />
            )}

            {/* These routes are protected and require authentication */}
            <Route path="/user" element={<User />} />
            <Route path="/userProfile/:userId" element={<UserProfile />} />
            <Route
              path="/vortexuserProfile/:userId"
              element={<VortexUserProfile />}
            />
            <Route path="/content" element={<Content />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/security" element={<Security />} />
            <Route path="reporting" element={<Reporting />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/AppManager" element={<AppManager />} />
            <Route path="/vortexappmanager" element={<VortexAppManager />} />
            <Route
              path="/vortexnotifications"
              element={<VortexNotification />}
            />
            <Route path="/Email" element={<Email />} />
            <Route path="/vortexData" element={<VortexDataAnalysis />} />
            <Route path="/vortexusers" element={<VortexUser />} />
            <Route path="/vortexemail" element={<VortexEmail />} />
            {/* Login route */}
            <Route path="/login" element={<Login />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default AuthorizedCom;
